import { render } from "./LegalNotice.vue?vue&type=template&id=546518dc&scoped=true"
const script = {}

import "./LegalNotice.vue?vue&type=style&index=0&id=546518dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546518dc"]])

export default __exports__